/* __next_internal_client_entry_do_not_use__ default auto */ import useEventCallback from '@mui/utils/useEventCallback';
export default useEventCallback;
